import { useTableStyles } from "@chakra-ui/react";
import { chakra, forwardRef, HTMLChakraProps } from "@chakra-ui/system";

export interface TableSubHeadProps extends HTMLChakraProps<"thead"> {}

export const TSubHead = forwardRef<TableSubHeadProps, "thead">((props, ref) => {
  const styles = useTableStyles();
  return <chakra.thead {...props} ref={ref} __css={styles.tsubhead} />;
});
